/* storybook-check-ignore */
const ChevronDown = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.86781 5.13219C2.38853 5.61147 2.38853 6.38853 2.86781 6.86781L5.37483 9.37483C5.85411 9.85411 6.63117 9.85411 7.11045 9.37483L9.61747 6.86781C10.0967 6.38853 10.0967 5.61147 9.61747 5.13219C9.13819 4.65291 8.36112 4.65291 7.88184 5.13219L6.24264 6.77139L4.60344 5.13219C4.12416 4.65291 3.34709 4.65291 2.86781 5.13219Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronDown;
